import { JsonSchemaInfoBasePropertiesFormProperties } from "../models/campaign-3.model";




export class MessageType{
  id:number;
  code: string;
  description: string;
  target_loyalty_class: string;
  flg_couponing_method: string;
  promo_emission: string;
  coupon_use_number: number;
}



export class ActionType{
  shortCode: string;
  code:string;
  description:string;
  flg_dpl: string;
  flg_kf: string;
  flg_state: string;
  form_def: any;
  form_json: any;
  id: number;
  name: string;
  ts_del: Date;
  ts_ins: Date;
  ts_upd: Date;
  user_del_id: number;
  user_ins_id: number;
  user_upd_id: number;
}

export class CouponType{
  id:number;
  code: string;
  description: string;
  target_loyalty_class: string;
  flg_couponing_method: string;
  promo_emission: string;
  coupon_use_number: number;
}

export class AdvantageType{
  id:number;
  code: string;
  description: string;
}

export class CouponInfoBaseForm{
  name: string;
  valid: boolean;
  schema: JsonSchemaInfoBasePropertiesFormProperties;
}

export class PreferredCoupon{
  id: number;
  name: string;
  int_note: string;
  campaign_id: number;
}

export class Campaign3DuplicateAction{
  idCampaignFrom: number;
  idCampaignTo: number;
  messageInstanceId: number;
  newActionname: string;
  start_date_emission: string;
  end_date_emission: string;
  start_date_fruition: string;
  end_date_fruition: string;
  codice_articolo: string;
  barcode: string;
  barcode_type_pid: number;
}

export class MessageInstanceObjectType {
  messageInstanceObjectTypeId: number;
  description: string;
  valMin: number | null;
  valMax: number | null;
  priority: number;
  defaultRule: string;
  defaultValue: string;
}

export class MessageInstanceRuleObjectTypeResponse {
  maxNumOptions: number;
  fieldType: string;
  field: string;
  uiType: string;
  messageInstanceRuleTypeId: number;
  messageInstanceRuleType: string;
  messageInstanceObjectTypeIdList: MessageInstanceObjectType[];
}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/models/campaign-3-info-base.model.ts